module.exports = __webpack_public_path__ + "img/spartan-work-order-square.8265ef3c.jpg";